export interface IvqConfig {}

export const PresetAreas = ['Playback'];

export const UiComponentArea = 'GuiArea';

export const KalturaPlayerSeekBarSelector = '.playkit-seek-bar';

export const KalturaPlayerBottomBarSelector = '.playkit-bottom-bar-area';
